import gsap from "gsap";

export default function initPage(isMobile, isTouch) {
  if (
    !document
      .querySelector("body")
      .classList.contains("page" || "page-template-page-special")
  )
    return;
  if (!isMobile) {
    gsap
      .timeline({
        scrollTrigger: {
          trigger: ".block-3",
          start: "top center",
          end: "bottom bottom",
          scrub: true,
        },
      })
      .fromTo(
        ".block-3 .bp .draw-on-scroll",
        {
          drawSVG: "0%",
        },
        {
          drawSVG: "100%",
          ease: "none",
        }
      );
  }
}
